export default __webpack_public_path__ + "media/images/features/local_delivery/episode7/LP_01-1ac5789044ac4f20c62758f3c975824d.jpg";